// Discount Popup
const disCloseModal = document.querySelector(".discount__close-modal");
const disModal = document.querySelector(".discount__modal");
const disOverlay = document.querySelector(".discount__overlay");
const disAddClasses = () => {
  disModal.classList.add("dn");
  disOverlay.classList.add("dn");
};
disCloseModal.addEventListener("click", disAddClasses);
disOverlay.addEventListener("click", disAddClasses);
// Close model on ESCAPE Key.
document.addEventListener("keydown", function (e) {
  console.log(e.key);
  if (e.key === "Escape" && !disModal.classList.contains(".dn")) {
    disAddClasses();
  }
});

let checkButtons = setInterval(() => {
  let bundleBtn = document.querySelectorAll('.t4s-bundle-addtocart');
  if (bundleBtn.length > 0) {
    bundleBtn.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        let qty = btn.closest('.t4s-product-atc-qty').querySelector('.t4s-quantity-input');
        btn.innerText = "ADDED";
        btn.classList.add('clicked');
        qty.classList.add('qty');
      });
    });
    clearInterval(checkButtons); // Stop checking once the buttons are found
  }
}, 500);

function add_to_cart() {
  let listItems = [];
  let totalFinalPrice = 0;
  const prod_clicked_elements = document.getElementsByClassName("clicked");
  const prod_input_qty = document.querySelectorAll('.t4s-quantity-input.qty');
  debugger;
  for (let i = 0; i < prod_clicked_elements.length; i++) {
    debugger;
    let prodId = prod_clicked_elements[i].dataset.variantId;
    let prodQty = prod_input_qty[i].dataset.currentQty;
    listItems.push({ id: parseInt(prodId), quantity: parseInt(prodQty) });
  }

  let formData = { items: listItems };
  if (listItems.length > 0) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const parsedState = JSON.parse(data);
        debugger;
        for (let i = 0; i < parsedState.items.length; i++) {
          totalFinalPrice += (parsedState.items[i].final_price / 100) * (parsedState.items[i].quantity);
        }
        if (totalFinalPrice > 25000) {
          disModal.classList.remove("dn");
          disOverlay.classList.remove("dn");
          disCloseModal.addEventListener("click", disAddClasses);
          disOverlay.addEventListener("click", disAddClasses);
        } else {
          redirectToCart();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  } else {
    show_warning_Modal();
  }
}

function redirectToCart() {
  window.location.href = "/cart";
}